import { types } from "../action-types";

const initialState = {
    loading: false,
    resp: [],
    error: false,
};

const getCompanyProfileDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_COMPANYPROFILEDETAILS_REQUESTED:
            return {
                ...state,
                loading: true,
            };

        case types.GET_COMPANYPROFILEDETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                resp: action.payload,
                error: false,
            };
        case types.GET_COMPANYPROFILEDETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                resp: [],
                error: true,
            };
        default:
            return state;
    }
};

export default getCompanyProfileDetailsReducer;
